// Generated by npm run generate-i18n-catalogs. Do not edit directly.

export const catalogRu = {
  "controls": {
    "boot": "Загрузка",
    "reset": "Сброс",
    "copyScreen": "Скопировать экран",
    "copyText": "Копировать текст",
    "pasteText": "Вставить текст",
    "saveState": "Сохранить состояние",
    "restoreState": "Восстановить состояние",
    "toggleSound": "Переключить звук",
    "settings": "Настройки",
    "debugPanel": "Панель отладки",
    "infoPanel": "Панель информации",
    "reportIssue": "Сообщить о проблеме",
    "privacyPolicy": "Политика конфиденциальности"
  },
  "config": {
    "speed": "Скорость",
    "display": "Настройки дисплея",
    "theme": "Тема",
    "openRetroControlPanel": "Панель управления",
    "resetSettings": "Сброс всех настроек",
    "useOpenApple": "Использовать клавишу {{modKey}} для Open Apple",
    "useShortcuts": "Использовать клавишу {{modKey}} для горячих клавиш",
    "useArrowKeys": "Использовать стрелки как джойстик",
    "scanlines": "CRT развёртка",
    "ghosting": "Эффект послесвечения",
    "crtDistortion": "Искажение ЭЛТ",
    "joystick": "Конфигурация джойстика"
  },
  "machine": {
    "slotConfigurator": "Слоты расширения"
  },
  "speed": {
    "snail": "Скорость улитки (0.1 МГц)",
    "slow": "Медленная (0.5 МГц)",
    "normal": "Нормальная (1 МГц)",
    "two": "2 МГц",
    "three": "3 МГц",
    "fast": "Быстрая (4 МГц)",
    "warp": "Безумная скорость"
  },
  "colors": {
    "color": "Цветной",
    "nofringe": "Цветной (без окантовки)",
    "green": "Зелёный",
    "amber": "Янтарный",
    "white": "Чёрно-белый",
    "inverse": "Чёрно-белый (инверсия)"
  },
  "themes": {
    "classic": "Классическая",
    "dark": "Тёмная",
    "minimal": "Минимальная"
  },
  "debug": {
    "helpPanel": "Показать панель помощи",
    "debugPanel": "Показать панель отладки",
    "expectinPanel": "Показать панель Apple exPectin",
    "helpTab": "Помощь",
    "debugTab": "Отладка",
    "breakpoints": "Точки останова",
    "memory": "Память",
    "stack": "Стек",
    "state": "Состояние CPU",
    "registers": "Регистры",
    "flags": "Флаги",
    "step": "Шаг",
    "stepOver": "Шаг через",
    "stepInto": "Шаг внутрь",
    "stepOut": "Шаг из",
    "resume": "Продолжить",
    "pause": "Пауза",
    "loadSymbolTable": "Загрузить таблицу символов",
    "disassembly": "Дизассемблирование"
  },
  "tour": {
    "welcome": "Добро пожаловать в эмулятор Apple2TS!",
    "clickNext": "Чтобы узнать больше, нажмите кнопку Далее.",
    "bootButton": "Нажмите здесь, чтобы запустить эмулятор.",
    "resetButton": "Нажмите здесь, чтобы перезагрузить Apple II и либо перезапустить, либо войти в BASIC.",
    "diskImages": "Выберите один из установленных образов дисков.",
    "floppyDisks": "Или щёлкните по одной из иконок дискет, чтобы загрузить образ диска.",
    "saveRestore": "Вы можете сохранить и восстановить полное состояние эмулятора с помощью этих кнопок.",
    "themeButton": "Нажмите здесь, чтобы изменить тему интерфейса эмулятора.",
    "endTour": "Вы достигли конца экскурсии. Нажмите кнопку глобуса экскурсии, чтобы попробовать одну из других экскурсий, или нажмите Завершить, чтобы начать использовать эмулятор.",
    "tourSelectorHint": "Нажмите на кнопку тура с глоусом, чтобы попробовать другой тур, или нажмите «Завершить», чтобы начать работу с эмулятором.",
    "settingsWelcome": "Apple2TS имеет полный набор элементов управления как для эмулятора, так и для Apple II. Чтобы узнать больше, нажмите кнопку Далее.",
    "mainControls": "Здесь вы можете загрузить и перезагрузить Apple II, восстановить и сохранить состояние, скопировать экран или вставить текст в эмулятор.",
    "snapshot": "В любой момент вы можете сделать снимок текущего состояния эмулятора, затем вернуться назад во времени к более раннему состоянию или снова перемотать вперёд. Вы также можете сохранить состояние эмулятора со всеми текущими снимками.",
    "pauseButton": "Вы можете приостановить эмулятор в любой момент, заморозив процессор 6502. Это полезно для приостановки действия в игре или входа в отладчик.",
    "debugButton": "Нажмите на жука, чтобы войти в режим отладки, где вы можете видеть внутреннее состояние процессора 6502. Нажмите ещё раз, чтобы вернуться в нормальный режим.",
    "configButtons": "Нижний ряд кнопок управляет состоянием Apple II, начиная со скорости эмулятора, цвета экрана и отключения звука.",
    "keyboardButtons": "Если клавиша caps lock включена, то все печатаемые символы - ЗАГЛАВНЫЕ.",
    "altArrowKeys": "Следующая клавиша определяет, используется ли клавиша {{modKey}} для горячих клавиш или клавиши Apple II Open Apple. Последняя клавиша определяет, можно ли использовать клавиши стрелок как джойстик Apple II.",
    "clearCookies": "Apple2TS автоматически сохраняет текущие настройки эмулятора как cookies браузера. Нажмите эту кнопку, чтобы сбросить эти настройки и удалить cookies.",
    "debugWelcome": "Apple2TS имеет богатый набор инструментов для анализа и отладки ассемблерного кода 6502. Чтобы узнать больше, нажмите кнопку Далее.",
    "debugIcon": "Нажмите на иконку Жука во вкладках Информация, чтобы просмотреть панель отладки.",
    "debugPause": "Нажмите кнопку Пауза, чтобы приостановить или возобновить выполнение эмулятора.",
    "debugControls": "Теперь, когда мы приостановлены, мы можем пошагово проходить через дизассемблированный код, используя кнопки Перешагнуть, Войти и Выйти. Мы также можем быстро перейти к текущему адресу счётчика программы (PC).",
    "debugDisassembly": "Здесь мы видим дизассемблированный код с шестнадцатеричными адресами, трёхбуквенной инструкцией и любыми значениями или адресами. Если вы наведёте мышь на зелёное значение, появится подсказка с текущим значением. Нажатие на синий адрес прокрутит к этому местоположению. Вы также можете щёлкнуть в левом поле, чтобы добавить или удалить точки останова.",
    "debugInfo": "В центре у нас есть дамп стека и карта памяти. Карта памяти обновляется в реальном времени и показывает вам, какие банки памяти в настоящее время активны.",
    "debugMemory": "Последняя секция показывает память Apple II. Вы можете использовать выпадающий список для изучения различных частей памяти. Если вы переключитесь на одну из страниц HGR, вы получите увеличенный вид экрана высокого разрешения, связанный с местоположениями памяти. Вы также можете искать шестнадцатеричные значения или ASCII строки и сохранять память в файл.",
    "back": "Назад",
    "close": "Закрыть",
    "last": "Завершить",
    "next": "Далее",
    "nextLabelWithProgress": "Далее (Шаг {step} из {steps})",
    "skip": "Закрыть",
    "guidedTour": "Экскурсия",
    "mainLabel": "Управляемый тур: Главный",
    "settingsLabel": "Управляемый тур: Настройки",
    "debugLabel": "Управляемый тур: Отладка"
  },
  "disk": {
    "drive1": "Привод 1",
    "drive2": "Привод 2",
    "hardDisk": "Жёсткий диск",
    "eject": "Извлечь диск",
    "insert": "Вставить диск",
    "writeProtected": "Защищён от записи",
    "readWrite": "Чтение/Запись",
    "empty": "Пустой",
    "loading": "Загрузка...",
    "selectDisk": "Выбрать образ диска",
    "browse": "Обзор",
    "newReleases": "Новые выпуски",
    "writeProtectDisk": "Защита диска от записи",
    "saveDiskToDevice": "Сохранить диск",
    "saveDiskTo": "Сохранить диск на",
    "saveDiskToMenu": "Сохранить диск на >",
    "addToFavorites": "Добавить в избранное",
    "downloadDisk": "Скачать диск",
    "downloadWoz": "Скачать образ диска WOZ",
    "downloadAndEjectDisk": "Скачать и извлечь диск",
    "ejectDisk": "Извлечь диск",
    "ejectAllDisks": "Извлечь все диски",
    "saveDiskToOneDrive": "Сохранить диск на OneDrive",
    "saveDiskToGoogleDrive": "Сохранить диск на Google Drive",
    "loadDisk": "Загрузить диск",
    "loadAdditionalDisks": "Загрузить дополнительный диск...",
    "loadDiskFrom": "Загрузить диск из",
    "loadDiskFromMenu": "Загрузить диск из >",
    "loadDiskFromDevice": "Загрузить диск",
    "loadDiskFromDeviceReadOnly": "Загрузить диск с устройства (Только чтение)",
    "loadDiskFromDeviceReadWrite": "Загрузить диск с устройства (Чтение/Запись)",
    "loadDiskFromInternetArchive": "Загрузить диск из Internet Archive",
    "loadDiskFromOneDrive": "Загрузить диск из OneDrive",
    "loadDiskFromGoogleDrive": "Загрузить диск из Google Drive",
    "insertBlankDisk": "Вставить чистый диск",
    "syncEveryMinute": "Синхронизировать каждую минуту",
    "syncEvery5Minutes": "Синхронизировать каждые 5 минут",
    "pauseSyncing": "Приостановить синхронизацию",
    "syncNow": "Синхронизировать сейчас",
    "modified": "изменён",
    "synced": "синхронизирован",
    "diskImage": "Образ диска",
    "diskDrivesAndDevices": "дисководы и устройства",
    "syncedAt": "Синхронизировано {{date}}",
    "clickToLoadDiskImage": "Нажмите, чтобы загрузить образ(ы) диска",
    "clickToRemoveFromDiskCollection": "Нажмите, чтобы удалить из коллекции дисков",
    "clickToAddToDiskCollection": "Нажмите, чтобы добавить в коллекцию дисков",
    "byCreator": "от {{creator}}",
    "clickToViewDetails": "Нажмите, чтобы просмотреть подробности",
    "standbyDisks": "Ожидающие диски (Нажмите, чтобы сменить диск)"
  },
  "help": {
    "title": "Apple2TS",
    "subtitle": "Эмулятор Apple IIe на TypeScript",
    "credit": "(c) {{year}} Chris Torrence и участники проекта Apple2TS",
    "keyboardShortcuts": "Горячие клавиши",
    "shortcutsUnavailable": "Сочетания клавиш эмулятора с {{keyMod}} недоступны, пока эта клавиша используется в качестве клавиши Open Apple. Сочетания Ctrl+0–Ctrl+5 по-прежнему позволяют выбирать скорость эмулятора.",
    "diskImages": "Образы дисков:",
    "diskContainers": "Сжатые архивы:",
    "multiDiskNotice": "Смена нескольких дисков: Нажмите на значок нескольких дисков, чтобы открыть меню быстрой смены. Архивы с несколькими дисками (.zip, .7z, .gz) автоматически загружаются в список смены.",
    "urlParameters": "Опциональные параметры URL",
    "examples": "Примеры",
    "mobileInstructions": "Мобильные платформы:",
    "tapScreen": "Коснитесь экрана, чтобы показать клавиатуру.",
    "arrowKeys": "Нажмите клавиши стрелок, esc или tab, чтобы отправить эти клавиши в эмулятор.",
    "ctrlKey": "Чтобы отправить управляющий символ, нажмите кнопку ctrl один раз. Затем коснитесь экрана, чтобы показать клавиатуру, и нажмите нужную клавишу. Кнопка ctrl будет автоматически отпущена.",
    "ctrlLock": "Чтобы отправить несколько управляющих символов, нажмите кнопку ctrl дважды, чтобы заблокировать её (обозначается зелёной точкой). Затем коснитесь экрана, чтобы показать клавиатуру, и нажмите нужные клавиши. Нажмите кнопку ctrl ещё раз, чтобы отпустить её.",
    "appleKeys": "Клавиши open apple и closed apple ведут себя так же, как клавиша ctrl.",
    "openAppleKey": "Open Apple: нажмите левый Alt/Option",
    "closedAppleKey": "Closed Apple: Правый Alt/Option",
    "joystickKeys": "Клавиши джойстика: Цифровая клавиатура 8/2/4/6 (7/9/1/3), 0/5, ./Enter",
    "onScreenKeyboard": "Для экранной клавиатуры, CTRL или ESC:\nнажать клавишу один раз, затем нужную клавишу.",
    "urlParametersBody": "Для необязательных параметров URL добавьте их в URL после вопросительного знака (?) и разделяйте несколько параметров символом амперсанда (&). Используйте # для указания образа диска. Примеры см. в диалоге конструктора ссылок.",
    "exampleLinks": {
      "totalReplayDebugging": "Total Replay с отладкой",
      "totalReplayChoplifter": "Total Replay, загрузить Choplifter, встроенный режим",
      "a2Desktop": "A2DeskTop 2MG с быстрой скоростью и цветом",
      "embeddedBasic": "Встроенная программа Applesoft BASIC",
      "binaryHexAddress": "Бинарный файл с Hex адресом"
    },
    "links": "Ссылки",
    "resourceLinks": {
      "desktopApp": "Настольное приложение Apple2TS",
      "corsProxy": "CORS прокси от Corsfix",
      "silverCjkFont": "Silver CJK Pixel Font"
    }
  },
  "messages": {
    "loading": "Загрузка...",
    "error": "Ошибка",
    "success": "Успех",
    "confirm": "Подтвердить",
    "cancel": "Отмена",
    "ok": "ОК",
    "on": "включён",
    "off": "выключен",
    "confirmTheme": "Перезагрузить эмулятор и применить эту тему сейчас?",
    "confirmReset": "Сбросить все настройки к значениям по умолчанию?",
    "fileNotFound": "Файл не найден",
    "invalidFile": "Недопустимый формат файла",
    "diskInserted": "Диск вставлен",
    "diskEjected": "Диск извлечён"
  },
  "keyboard": {
    "space": "Пробел",
    "return": "Ввод"
  },
  "audio": {
    "speaker": "Динамик",
    "midi": "MIDI",
    "configuration": "Конфигурация звука",
    "volume": "Громкость",
    "mute": "Отключить звук",
    "waveform": "Форма волны"
  },
  "print": {
    "printer": "Принтер",
    "print": "Печать",
    "clear": "Очистить",
    "save": "Сохранить вывод",
    "dumpScreen": "Вывести текущий экран на принтер",
    "dumpScreenInverse": "Вывести текущий экран (Инверсия)",
    "sendToPrinter": "Отправить на принтер",
    "tearOff": "Оторвать страницу и сбросить",
    "printedPage": "Напечатанная страница",
    "printerConfig": "Настройка принтера",
    "pageLength": "Длина страницы",
    "pageLengthLetter": "11 дюймов (Letter)",
    "pageLengthA4": "11,7 дюймов (A4)",
    "pageLengthTwelve": "12 дюймов"
  },
  "device": {
    "machineConfiguration": "Конфигурация машины",
    "midiDeviceSelect": "Выбор MIDI устройства",
    "serialPortSelect": "Выбор последовательного порта",
    "mockingboardWaveform": "Форма волны Mockingboard"
  },
  "collection": {
    "showApple2TSCollection": "Показать коллекцию Apple2TS",
    "showNewReleases": "Показать новые выпуски",
    "showFavorites": "Показать избранное",
    "chooseDiskImage": "Выбрать образ диска",
    "diskCollection": "Коллекция дисков",
    "clickToShowDetails": "Нажмите, чтобы показать подробности для",
    "clickToLoadDisk": "Нажмите, чтобы загрузить диск",
    "diskIsNewRelease": "Диск является новым выпуском",
    "diskIsApple2TSCollection": "Диск является частью коллекции Apple2TS",
    "diskIsInternetArchive": "Диск является частью Internet Archive",
    "clickToRemoveFromCollection": "Нажмите, чтобы удалить из коллекции дисков",
    "clickToAddToCollection": "Нажмите, чтобы добавить в коллекцию дисков",
    "diskIsSyncedVia": "Диск синхронизирован через",
    "loadDiskIntoDrive": "Загрузить диск в привод",
    "exportDisksToHdv": "Экспорт дисков в HDV",
    "export": "Экспорт",
    "clickToRemoveFromSelected": "Нажмите, чтобы удалить из выбранных дисков",
    "clickToAddToSelected": "Нажмите, чтобы добавить к выбранным дискам",
    "reportExportIssue": "Сообщить о проблеме экспорта"
  },
  "debugControls": {
    "goBackInTime": "Вернуться во времени",
    "takeSnapshot": "Сделать снимок",
    "goForwardInTime": "Вперёд во времени",
    "saveStateWithSnapshots": "Сохранить состояние со снимками",
    "resume": "Возобновить",
    "pause": "Пауза",
    "trace": "Трассировка",
    "tracing": "Трассировка...",
    "downloadTraceLog": "Скачать журнал трассировки"
  },
  "fullscreen": {
    "fullScreen": "Полный экран"
  },
  "internetArchive": {
    "searchPlaceholder": "Введите название программы или нажмите на одну из категорий выше",
    "go": "ПОИСК"
  },
  "basic": {
    "newProgram": "Новая программа",
    "runFromBeginning": "Запустить с начала",
    "break": "Прервать",
    "continueRunning": "Продолжить выполнение",
    "stepProgram": "Пошаговое выполнение программы",
    "resumeOutput": "Возобновить вывод",
    "freezeOutput": "Заморозить вывод",
    "importProgram": "Импортировать программу...",
    "exportProgram": "Экспортировать программу...",
    "renumberProgram": "Перенумеровать программу",
    "rebuildProgram": "Восстановить программу из памяти",
    "displaySettings": "Настройки дисплея",
    "autoLineNumbering": "Автоматическая нумерация строк",
    "capitalizeKeywords": "Ключевые слова с заглавной буквы",
    "rebuildWarning": "Это заменит текущую программу версией, восстановленной из памяти Apple II. Вы потеряете все несохраненные изменения. Вы уверены?",
    "variable": "Переменная",
    "value": "Значение"
  },
  "expectin": {
    "runScript": "Запустить скрипт",
    "stopScript": "Остановить скрипт"
  },
  "saveDisassembly": {
    "title": "Сохранить дисассемблер",
    "startAddress": "Начальный адрес $",
    "endAddress": "Конечный адрес $",
    "includeLabels": "Включить метки символов",
    "separatorLines": "Разделительные линии после JMP, RTS"
  },
  "gamepad": {
    "useArrowKeys": "Стрелки как джойстик",
    "siriusJoyport": "Режим Sirius Joyport"
  },
  "traceSettings": {
    "title": "Настройки трассировки",
    "settings": "Настройки"
  },
  "linkBuilder": {
    "startupOptionsTab": "Параметры запуска",
    "speedNames": {
      "two": "2 МГц",
      "three": "3 МГц",
      "warp": "Безумная"
    },
    "ramDiskSizes": {
      "512": "512",
      "1024": "1024",
      "4096": "4096",
      "8192": "8192"
    },
    "slots": {
      "configure": "Настройка карт расширения",
      "slot": "Слот {{slot}}:",
      "cardNone": "Нет (пусто)"
    },
    "additionalDiskDrives": "Дополнительные дисководы",
    "slot6Drive1": "Слот 6 Дисковод 1 (Флоппи 1)",
    "slot6Drive2": "Слот 6 Дисковод 2 (Флоппи 2)",
    "slot7Drive1": "Слот 7 Дисковод 1 (Жесткий диск 1)",
    "slot7Drive2": "Слот 7 Дисковод 2 (Жесткий диск 2)",
    "slot2Drive1": "Слот 2 Дисковод 1 (VERA SD)",
    "slot4Drive1": "Слот 4 Дисковод 1 (VERA SD)",
    "addAdditionalDisk": "Добавить дополнительный диск для смены",
    "removeDisk": "Удалить этот диск",
    "addAnotherDisk": "Добавить еще один диск",
    "diskPlaceholder": "Имя файла диска {num} (например, sideB.woz|Диск со сценарием)"
  },
  "startup": {
    "welcome": "Добро пожаловать в Apple2TS",
    "subtitle": "Эмулятор Apple II на TypeScript",
    "copyright": "(c) {{year}} C.Torrence + соавторы",
    "diskCollections": "Нажмите значок Коллекций дисков\nдля загрузки диска или игры."
  },
  "retroControl": {
    "machine": "Машина",
    "fullscreen": "Полный экран",
    "diskCollection": "Диски",
    "diskDrives": "Дисководы",
    "display": "Экран",
    "monitorMode": "Режим монитора",
    "monitorModeChoice": {
      "ntsc": "NTSC",
      "rgb": "RGB"
    },
    "sound": "Звук",
    "options": "Параметры",
    "skin": "Оформление",
    "personalization": "Персонализация",
    "text": "Текст",
    "background": "Фон",
    "border": "Рамка",
    "iigsColor": {
      "black": "Чёрный",
      "red": "Красный",
      "darkBlue": "Тёмно-синий",
      "purple": "Фиолетовый",
      "darkGreen": "Тёмно-зелёный",
      "darkGray": "Тёмно-серый",
      "mediumBlue": "Синий",
      "lightBlue": "Голубой",
      "brown": "Коричневый",
      "orange": "Оранжевый",
      "lightGray": "Светло-серый",
      "pink": "Розовый",
      "lightGreen": "Светло-зелёный",
      "yellow": "Жёлтый",
      "aquamarine": "Аквамарин",
      "white": "Белый"
    },
    "keyboard": "Клавиатура",
    "joystick": "Джойстик",
    "slots": "Слоты",
    "devices": "Устройства",
    "printerPort": "Порт принтера",
    "modemPort": "Порт модема",
    "quit": "Выход",
    "apple2tsCollection": "Коллекция Apple2TS",
    "newReleases": "Новинки",
    "favorites": "Избранное",
    "exportDisksToHdv": "Экспорт дисков в HDV",
    "noDiskDrivesAvailable": "Нет доступных дисководов",
    "select": "Выбрать",
    "open": "Открыть",
    "load": "Загрузить",
    "go": "Перейти",
    "save": "Сохранить",
    "clipboard": "Буфер обмена",
    "cancelEsc": "Отмена:Esc",
    "color": "Цвет",
    "systemSpeed": "Скорость системы",
    "other": "Другое",
    "timeMachine": "Снимки",
    "ports": "Порты",
    "language": "Язык",
    "retroTheme": "Ретро",
    "lowercaseInput": "Ввод строчными буквами",
    "openAppleKey": "Клавиша Open Apple",
    "sortOrder": "Сортировка",
    "card": {
      "empty": "Пусто",
      "mockingboard": "Mockingboard"
    }
  }
}
